import axios from "axios";
import { REACT_APP_API_URL } from "../env";

const api = axios.create({
  baseURL: REACT_APP_API_URL,
  withCredentials: true,
});

export const RBAC_BASE = "api/admin/rbac";

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      // Only redirect if user is NOT authenticated (token expired/cleared)
      const isAuthenticated = localStorage.getItem("isAuthenticated") === "true";
      if (!isAuthenticated) {
        const path = window.location.pathname;
        if (path !== "/signin" && path !== "/hrms/login") {
          const userType = localStorage.getItem("userType");
          window.location.href = userType === "hrms" ? "/hrms/login" : "/signin";
        }
      }
    }
    if (err.response?.status === 403) {
      window.location.href = "/unauthorized";
    }
    return Promise.reject(err);
  }
);

export default api;